module.exports = __webpack_public_path__ + "img/photo-0138.7f867255.jpg";